/**  Типы договоров. */
export enum ContractsTypes {
  /** Отсутствует. */
  None = 0,

  /** Счета до востребования. */
  DepositAccounts = 1,

  /** Cрочные счета. */
  TimeAccounts = 2,

  /** Текущие счета. */
  CurrentAccount = 3,

  /** Карточные счета. */
  CardAccount = 4,

  /** Кредитные счета. */
  CreditAccount = 5
}
